import { Preferences, sanitizePartial } from "./types";

export type StoredPrefs = { pending: boolean; values: Partial<Preferences> };

export const storageKey = (userId: number) => `antecipe.prefs.v1.${userId}`;

// Toda leitura/escrita em try/catch: aba anônima, cota cheia e dados de site bloqueados lançam (Review Focus 1).
export function readStored(userId: number): StoredPrefs | null {
  try {
    const raw = window.localStorage.getItem(storageKey(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return { pending: Boolean(parsed.pending), values: sanitizePartial(parsed.values) };
  } catch {
    return null;
  }
}

export function writeStored(userId: number, stored: StoredPrefs): boolean {
  try {
    // Só preferência válida chega ao disco (chamadores JS podem passar qualquer objeto).
    const safe: StoredPrefs = { pending: Boolean(stored?.pending), values: sanitizePartial(stored?.values) };
    window.localStorage.setItem(storageKey(userId), JSON.stringify(safe));
    return true;
  } catch {
    return false;
  }
}

export function clearStored(userId: number): void {
  try {
    window.localStorage.removeItem(storageKey(userId));
  } catch {
    /* sem storage: nada a limpar */
  }
}
